
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSafetyDepthsShowProposal as ObiChartSafetyDepthsShowProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-safety-depths-show-proposal.js';
 
 
 

 
 export const ObiChartSafetyDepthsShowProposal = createComponent({
   react: React,
   tagName: 'obi-chart-safety-depths-show-proposal',
   elementClass: ObiChartSafetyDepthsShowProposalElement,
   events: {
     
   }
  });
 
 